export interface ParsedStreamer {
  platform: 'twitch' | 'youtube' | 'kick';
  handle: string;
  name: string;
  raw: string;
}

function slug(s: string) {
  return s.toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
}

export function parseStreamerUrl(input: string): ParsedStreamer | null {
  const raw = input.trim();
  if (!raw) return null;
  let url: URL | null = null;
  try {
    url = new URL(raw.includes('://') ? raw : `https://${raw}`);
  } catch {
    return null;
  }
  const host = url.hostname.replace(/^www\./, '');
  const seg = url.pathname.split('/').filter(Boolean);

  if (host.endsWith('twitch.tv')) {
    const handle = seg[0];
    if (!handle) return null;
    return { platform: 'twitch', handle, raw, name: `twitch-${slug(handle)}` };
  }
  if (host.endsWith('kick.com')) {
    const handle = seg[0];
    if (!handle) return null;
    return { platform: 'kick', handle, raw, name: `kick-${slug(handle)}` };
  }
  if (host.endsWith('youtube.com') || host === 'youtu.be') {
    const handleSeg = seg.find((s) => s.startsWith('@')) || (seg[0] === 'channel' ? seg[1] : seg[0]);
    if (!handleSeg) return null;
    const handle = handleSeg.replace(/^@/, '');
    return { platform: 'youtube', handle, raw, name: `yt-${slug(handle)}` };
  }
  return null;
}

export function streamerPayloadFromParsed(p: ParsedStreamer) {
  const payload: Record<string, unknown> = { name: p.name };
  if (p.platform === 'twitch') payload.twitch_channel = p.handle;
  else if (p.platform === 'youtube') payload.youtube_channel_id = p.handle;
  else if (p.platform === 'kick') payload.kick_channel = p.handle;
  return payload;
}
